import React from 'react';
import { DatePickerTypeV2, DatePickerV2 } from '@wajeez-web/components/ui';
import { FieldValues, UseControllerProps } from 'react-hook-form';

import { DateFormType, DateTimeFormType } from '../Types';
import { FormInputController } from '../FormInputController';

export interface FormDatePickerInputV2Props<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields>,
    DatePickerTypeV2 {
  fieldMeta: DateFormType | DateTimeFormType;
  validationErrorMessages?: Partial<{
    required: string;
    pattern: string;
    minLength: string;
    maxLength: string;
  }>;
  readOnly?: boolean;
}

export const FormDatePickerV2Input = <TFormFields extends FieldValues>({
  name,
  fieldMeta,
  validationErrorMessages,
  readOnly,
  ...props
}: FormDatePickerInputV2Props<TFormFields>) => {
  return (
    <FormInputController
      name={name}
      fieldMeta={fieldMeta}
      renderInput={({ ...controllerProps }) => (
        <DatePickerV2
          label={fieldMeta.label}
          placeholder={fieldMeta.placeHolder}
          required={fieldMeta.required}
          {...controllerProps}
          {...props}
        />
      )}
      {...props}
    />
  );
};
